module.exports = __webpack_public_path__ + "media/crypto_powerlist/X-07db78b9.png";